require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-project-gambia-covid-19-preparedness-and-response-project.json") })
        }
      }, "path---en-us-project-gambia-covid-19-preparedness-and-response-project");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-project-gambia-covid-19-preparedness-and-response-project!./.cache/json/en-us-project-gambia-covid-19-preparedness-and-response-project.json
// module id = 508
// module chunks = 231608221292675